import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'
import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import type { ImageXScrollEffectsCssFeature } from './imageXScrollEffects.types'
import { imageXScrollEffects } from './imageXScrollEffectsCompNode'
import { imageXScrollEffectsDomApplier } from './imageXScrollEffectsDomApplier'

export const imageXScrollEffectsCssFeature: ImageXScrollEffectsCssFeature = {
	featureName: 'imageXScrollEffects',
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: { imageXScrollEffects },
	intermediateNodes: {},
	dataMaps: ['document_data'],
	domApplier: imageXScrollEffectsDomApplier,
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(imageXScrollEffectsCssFeature)
}
export const editor: BindFeature = page
